<template>
  <v-card>
    <v-card-title class="d-flex justify-space-between align-center">
      <span class="text-h6 font-weight-bold">📋 الاستبيانات</span>
      <v-btn color="primary" @click="$emit('create', {survey})">+ إنشاء استبيان جديد</v-btn>
    </v-card-title>

   <v-data-table
  :headers="headers"
  :items="surveys"
  class="elevation-1"
  item-key="name"
  :items-per-page="5"
  dark
>
  <template #headers>
    <tr>
      <th class="text-right">الاسم</th>
      <th class="text-right">تاريخ البدء</th>
      <th class="text-right">تاريخ الانتهاء</th>
      <th class="text-right">التذكير الأول</th>
      <th class="text-right">التذكير الثاني</th>

      <th class="text-right">الإجراءات</th>
    </tr>
  </template>

  <template #item="{ item }">
    <tr>
      <td>{{ item.name }}</td>
      <td>{{ momentFilter(item.startDate) }}</td>
      <td>{{ momentFilter(item.endDate) }} </td>
      <td>{{ momentFilter(item.firstReminder) }}</td>
      <td>{{ momentFilter(item.secondReminder) }}</td>

      <td>
        <v-btn icon size="small" color="primary" title="تعديل" @click="$emit('edit', item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon size="small" color="red" title="حذف" @click="$emit('delete', item._id)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </td>
    </tr>
  </template>
</v-data-table>

  </v-card>
</template>

<script>
// import moment from 'moment'
import momentTZ from 'moment-timezone';

export default {
  props: {
    surveys: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      survey: {
        name: '',
        startDate: null,
        endDate: null,
        firstReminder: null,
        secondReminder: null,
        questions: [],
      },
      headers: [
        { text: 'الاسم', value: 'name' },
        { text: 'تاريخ البدء', value: 'startDate' },
        { text: 'تاريخ الانتهاء', value: 'endDate' },
        { text: 'الإجراءات', value: 'actions', sortable: false },
      ],
    };
  },
  methods: {
    momentFilter: function (date) {
      return momentTZ(date).format('YYYY-MM-DD HH:mm a')
    },

    formatDate(date) {
      if (!date) return '—';
      return new Date(date).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    },
  },
};
</script>
